module.exports = __webpack_public_path__ + "img/background111.936c6830.jpg";